/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef, useState } from 'react'
import * as Yup from 'yup'
import { Link, useNavigate } from 'react-router-dom'
import { Field, FormikProvider, useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { register } from '../../../redux/features/auth/authActions'
import { MESSAGES } from '../../../utlis/messages'
import FieldInputText from '../../common/FieldInputText'
import { useLocation } from 'react-router-dom';
import SubmitButton from '../../common/SubmitButton'

interface LocationState {
  email?: string;
}
const validationSchema = Yup.object({
  email: Yup.string().email(MESSAGES.INVALID_EMAIL_MESSAGE).required(MESSAGES.EMAIL_REQUIRED),
  password: Yup.string().min(8, MESSAGES.PASSWORD_LENGTH_MESSAGE).required(MESSAGES.PASSWORD_REQUIRED),
});

export function Registration() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const authState = useSelector((state: any) => state.auth);
  const location = useLocation() as { state: LocationState };
  const emailFromState = location.state?.email || '';

  const initialValues = {
    email: emailFromState,
    password: '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          ...values,
        };

        const response = await dispatch(register({ values: payload, navigate }));
      } catch (error) {
        console.error("Registration failed:", error);
      }
    },
  });

  return (
    <FormikProvider value={formik}>
      <form
        className='form w-100 authWrapper'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_register_form'
      >
        <div className='text-center mb-5'>
          <h1 className='text-dark fw-bolder mb-3'>{MESSAGES.SAVE_PASSWORD}</h1>
        </div>

        <div className='fv-row mb-3'>
          <Field name="email" label={MESSAGES.EMAIL} type="email" required component={FieldInputText} placeholder={MESSAGES.EMAIL} disabled={!!emailFromState} />
        </div>

        <div className='fv-row mb-3'>
          <Field name="password" label={MESSAGES.PASSWORD} type="password" required component={FieldInputText} placeholder={MESSAGES.PASSWORD} />
        </div>

        <div className='d-grid mb-3'>
          <SubmitButton title="Iscrizione" type="submit" loading={authState.loading} />
        </div>

        {/* Add Sign-in Link */}
        <div className='text-center'>
          <span className='text-gray-600 fw-semibold'>{MESSAGES.DETAILS_ALREADY_SAVED}{" "}
            <Link to='/auth/login' className='link-primary'>
              {MESSAGES.LOGIN}
            </Link>
          </span>
        </div>
      </form>
    </FormikProvider>
  )
}
